import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "landing.app.title",
    },
    description: {
        id: "landing.app.description",
    },
    title1: {
        id: "landing.app.1.t",
    },
    description1: {
        id: "landing.app.1.d",
    },
    title2: {
        id: "landing.app.2.t",
    },
    description2: {
        id: "landing.app.2.d",
    },
    title3: {
        id: "landing.app.3.t",
    },
    description3: {
        id: "landing.app.3.d",
    },
    title4: {
        id: "landing.app.4.t",
    },
    title5: {
        id: "landing.app.5.t",
    },
    description5: {
        id: "landing.app.5.d",
    },
    title6: {
        id: "landing.app.6.t",
    },
    description6: {
        id: "landing.app.6.d",
    },
    title7: {
        id: "landing.app.7.t",
    },
    description7: {
        id: "landing.app.7.d",
    },
    title8: {
        id: "landing.app.8.t",
    },
    description8: {
        id: "landing.app.8.d",
    },
});

export default messages;
